/**
 * Labstep
 *
 * @module core/DataGrid/CellEditor
 * @desc Generic CellEditor parent component
 */

import { DataGridCellEditorDate } from 'labstep-web/core/DataGrid/CellEditor/Date';
import { DataGridCellEditorFile } from 'labstep-web/core/DataGrid/CellEditor/File';
import { DataGridCellEditorSearchSelect } from 'labstep-web/core/DataGrid/CellEditor/SearchSelect';
import { DataGridCellEditorSearchSelectModal } from 'labstep-web/core/DataGrid/CellEditor/SearchSelect/Modal';
import { DataGridCellEditorSelect } from 'labstep-web/core/DataGrid/CellEditor/Select';
import { DataGridCellEditorShowEditOptions } from 'labstep-web/core/DataGrid/CellEditor/ShowEdit/Options';
import type { ParentEntityType } from 'labstep-web/core/Form/ShowEdit/SearchSelect/types';
import type { Entity } from 'labstep-web/models/entity.model';
import React from 'react';
import type { ICellEditorDateProps } from './Date/types';
import type { ICellEditorFileProps } from './File/types';
import type { ICellEditorSearchSelectModalProps } from './SearchSelect/Modal/types';
import type { ICellEditorSearchSelectProps } from './SearchSelect/types';
import type { ICellEditorSelectProps } from './Select/types';
import type { ICellEditorShowEditOptionsProps } from './ShowEdit/Options/types';

export class DataGridCellEditor extends React.Component {
  public static Date: React.FC<ICellEditorDateProps<Entity>>;

  public static File: React.FC<ICellEditorFileProps<Entity>>;

  public static SearchSelect: React.FC<
    ICellEditorSearchSelectProps<Entity>
  >;

  public static Select: React.FC<ICellEditorSelectProps<Entity>>;

  public static SearchSelectModal: React.FC<
    ICellEditorSearchSelectModalProps<ParentEntityType>
  >;

  public static ShowEditOptions: React.FC<
    ICellEditorShowEditOptionsProps<Entity>
  >;
}

DataGridCellEditor.Date = DataGridCellEditorDate;
DataGridCellEditor.File = DataGridCellEditorFile;
DataGridCellEditor.SearchSelect = DataGridCellEditorSearchSelect;
DataGridCellEditor.Select = DataGridCellEditorSelect;
DataGridCellEditor.SearchSelectModal =
  DataGridCellEditorSearchSelectModal;
DataGridCellEditor.ShowEditOptions =
  DataGridCellEditorShowEditOptions;
